module.exports = __webpack_public_path__ + "static/media/icon-3.bf8d2f67.svg";